import { Routes, Route } from 'react-router-dom';
import './App.scss';
import Homepage from './pages/Homepage';
import { analytics } from 'firebase-config';
import { logEvent } from "firebase/analytics";

function App() {

  logEvent(analytics, 'screen_view', {
    firebase_screen: 'Home', 
    firebase_screen_class: 'homepage'
  });

  return (
    <div className="App pg-container" id="app">
      <Routes>
        <Route path="/" element={<Homepage />} />
      </Routes>
    </div>
  );
}

export default App;
